import {Component, OnInit, ViewChild} from "@angular/core";
import {MatTableGeneratorComponent} from "../../shared/mat-table-generator/mat-table-generator.component";
import {RoleService} from "../../services/role.service";
import {Chargeback, ChargebackStatus} from "../../dto/card";
import {toDateString} from "../../providers/app-date-adapter";
import {MultiCrudDataSource} from "../../table-datasouces/multi-crud.datasource";
import {Company} from "../../dto/company";
import {ChargebacksService} from "../services/chargebacks.service";

@Component({
  selector: 'app-chargebacks',
  templateUrl: './chargebacks.component.html',
  styleUrls: ['./chargebacks.component.css']
})
export class ChargebacksComponent implements OnInit {
  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  constructor(
    private chargebackService: ChargebacksService,
    private roleService: RoleService,
  ) { }

  chargebackStatus = ChargebackStatus;

  columns = [

    { columnDef: 'requestDate', header: 'Request Date', cell: (row: Chargeback) => `${toDateString(row.creationDate)}` },
    { columnDef: 'token', header: 'Token', cell: (row: Chargeback) => `${row.card.token}` },
    { columnDef: 'customer.firstName', header: 'First Name', cell: (row: Chargeback) => `${row.customer?.firstName || ""}` },
    { columnDef: 'customer.lastName', header: 'Last Name', cell: (row: Chargeback) => `${row.customer?.lastName || ""}` },
    { columnDef: 'merchantName', header: 'Merchant', cell: (row: Chargeback) => `${row.merchantName}` },
    { columnDef: 'transactionDate', header: 'Transaction Date', cell: (row: Chargeback) => `${toDateString(row.transactionDate)}` },
    { columnDef: 'amount', header: 'Amount', cell: (row: Chargeback) => `${row.transactionAmount}` },
    { columnDef: 'status', header: 'Status', cell: (row: Chargeback) => this.getStatusString(row.status) },

  ];
  dataSource = new MultiCrudDataSource(this.chargebackService);
  getRowClass = (item: Chargeback): string => {
    const classes = [];

    // TODO implement this if necessary
    return classes.join(' ');
  };
  getCustomerOverviewLink = (item: Chargeback): string => '/customers-overview/' + item.card.customerId.toString();
  companies: Company[] = [];
  public dateFiltersList = [
    { name: 'transaction_date', header: 'Transaction Date' },
    { name: 'request_date', header: 'Request Date' },
  ];
  getViewLink = (item: Chargeback): string => item.id.toString();
  getEditLink = (item: Chargeback): string => item.id.toString() + "/edit";


  ngOnInit(): void {

  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }

  private getStatusString(status: ChargebackStatus) {
    if ( status == ChargebackStatus.Request ) return "Requested";
    if ( status == ChargebackStatus.Pending ) return "Pending";
    if ( status == ChargebackStatus.Denied ) return "Denied";
    if ( status == ChargebackStatus.SuccessPending ) return "Approved";
    if ( status == ChargebackStatus.ChargebackExecuted ) return "Charged back";
    return "-";
  }
}
